export default __webpack_public_path__ + "static/media/nube.851a95b0.png";